import type { NonAgentType } from '@bb/domain/dist/types';
import { HOME_INSPECTION_TYPES } from '../../../../app/listing/constants';

export const agentAppointmentTypes: typeof HOME_INSPECTION_TYPES = [
  'Buyer/Broker',
  'Buyer Visit',
  'Agent Inspection',
  'Revisit',
  'Transaction Broker',
  'Dual Agency',
  'Home Inspection',
  'Appraisal',
  'Photographer',
  'Pest Control',
  ...HOME_INSPECTION_TYPES,
  'Information Request',
  'Final Walkthrough',
];

export const nonAgentTypes: NonAgentType[] = [
  'Appraisal',
  'Home Inspection',
  'Pest Control',
  'Photographer',
];

export const appointmentTypeToNonAgentLabel: Record<NonAgentType, string> = {
  Photographer: 'Photographer',
  'Pest Control': 'Pest Control',
  Appraisal: 'Appraiser',
  'Home Inspection': 'Inspector',
};
